import React, { Component } from "react";
import MaintainanceMode from "../../components/client/MaintainanceMode/MaintainanceMode";
import MyNavbar from "../../components/Navbar/MyNavbar";

export default class MaintainanceModePage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <MaintainanceMode />
      </div>
    );
  }
}
